export enum FileType {
    Image = 'Image', // 图片类型
    Video = 'Video', // 视频类型
    Model = 'Model', // 3D 模型
    Unknow = 'Unknow', // 其他未知
}
export enum FileTypeName {
    Image = '图片', // 图片类型
    Video = '视频', // 视频类型
    Model = '3D模型', // 3D 模型
    Unknow = '未知', // 其他未知
}